module.exports = __webpack_public_path__ + "static/img/10014 (2).4305f73.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10014 (2).webp
// module id = C+XZ
// module chunks = 14